import { useBrandLogo, useBrandSettings } from '../contexts/PortalPlatformDataContext';
export const useSellerLogoUrl = () => {
  var _useBrandSettings, _faviconUrl$src;
  const faviconUrl = (_useBrandSettings = useBrandSettings()) === null || _useBrandSettings === void 0 ? void 0 : _useBrandSettings.favicon;
  const brandLogoUrl = useBrandLogo();
  return (_faviconUrl$src = faviconUrl === null || faviconUrl === void 0 ? void 0 : faviconUrl.src) !== null && _faviconUrl$src !== void 0 ? _faviconUrl$src : brandLogoUrl === null || brandLogoUrl === void 0 ? void 0 : brandLogoUrl.src;
};